<app-discover-one></app-discover-one>
<app-contact></app-contact>